import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import JoinFamily from "@/pages/JoinFamily";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import CaregiverDashboard from "@/pages/CaregiverDashboard";
import PatientApp from "@/pages/PatientApp";
import AdminPanel from "@/pages/AdminPanel";
import Testimonials from "@/pages/Testimonials";
import SpaceHub from "@/pages/SpaceHub";
import FamilySpace from "@/pages/FamilySpace";
import ResidentNews from "@/pages/ResidentNews";
import ListenVoice from "@/pages/ListenVoice";
import Ephemeride from "@/pages/Ephemeride";
import Subscribe from "@/pages/Subscribe";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Contact from "@/pages/Contact";
import Stories from "@/pages/Stories";
import GroupSession from "@/pages/GroupSession";
import Gardiens from "@/pages/Gardiens";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to="/espaces" replace />} />
            <Route path="/connexion" element={<Login />} />
            <Route path="/inscription" element={<Register />} />
            <Route path="/rejoindre" element={<JoinFamily />} />
            <Route path="/mot-de-passe-oublie" element={<ForgotPassword />} />
            <Route path="/reinitialiser" element={<ResetPassword />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/gardiens" element={<Gardiens />} />
            <Route path="*" element={<Navigate to="/espaces" replace />} />
            <Route
              path="/espaces"
              element={
                <ProtectedRoute>
                  <SpaceHub />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ecouter/:recId"
              element={
                <ProtectedRoute>
                  <ListenVoice />
                </ProtectedRoute>
              }
            />
            <Route
              path="/nouvelles"
              element={
                <ProtectedRoute>
                  <ResidentNews />
                </ProtectedRoute>
              }
            />
            <Route
              path="/famille"
              element={
                <ProtectedRoute>
                  <FamilySpace />
                </ProtectedRoute>
              }
            />
            <Route
              path="/tableau-de-bord"
              element={
                <ProtectedRoute roles={["caregiver", "admin"]}>
                  <CaregiverDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <AdminPanel />
                </ProtectedRoute>
              }
            />
            <Route
              path="/temoignages"
              element={
                <ProtectedRoute>
                  <Testimonials />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ephemeride"
              element={
                <ProtectedRoute>
                  <Ephemeride />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contes"
              element={
                <ProtectedRoute>
                  <Stories />
                </ProtectedRoute>
              }
            />
            <Route
              path="/abonnement"
              element={
                <ProtectedRoute>
                  <Subscribe />
                </ProtectedRoute>
              }
            />
            <Route
              path="/paiement/succes"
              element={
                <ProtectedRoute>
                  <PaymentSuccess />
                </ProtectedRoute>
              }
            />
            <Route
              path="/patient/:patientId"
              element={
                <ProtectedRoute roles={["caregiver", "admin"]}>
                  <PatientApp />
                </ProtectedRoute>
              }
            />
            <Route
              path="/groupe/:groupId"
              element={
                <ProtectedRoute roles={["caregiver", "admin"]}>
                  <GroupSession />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
